import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
/**
 * META PIXEL PLACEHOLDER
 * ----------------------
 * Para conectar tu Meta Pixel, pegá tu código de pixel aquí.
 * Ejemplo:
 *
 * import ReactPixel from 'react-facebook-pixel';
 * const PIXEL_ID = 'TU_PIXEL_ID_AQUI';
 * ReactPixel.init(PIXEL_ID);
 * ReactPixel.pageView();
 *
 * O usá el paquete 'meta-pixel':
 * import { MetaPixel } from 'meta-pixel';
 */
render(<App data-id="element-348" />, document.getElementById('root'));